<template>
  <validation-observer ref="simpleRules">
    <b-form>

      <h6 class="mt-1">
        {{ $t('Periods') }}
      </h6>

      <b-row>
        <!-- Start Wave -->
        <b-col md="4">
          <b-form-group
            :label="$t('From')"
            label-for="mc-from"
          >
            <validation-provider
              #default="{ errors }"
              name="From"
              rules="required"
            >
              <v-select
                id="vue-select-from-wave"
                v-model="globalFilter.fromWave"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionPeriod"
                :placeholder="$t('from...')"
                :clearable="false"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- End Period -->
        <b-col md="4">
          <b-form-group
            :label="$t('To')"
            label-for="mc-to"
          >
            <validation-provider
              #default="{ errors }"
              name="To"
              rules="required"
            >
              <v-select
                id="vue-select-to-wave"
                v-model="globalFilter.toWave"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionPeriod"
                :placeholder="$t('...to')"
                :state="errors.length > 0 ? false:null"
                :clearable="false"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <!-- Rolling -->
          <b-form-group
            :label="$t('Rolling')"
            label-for="mc-rolling"
          >
            <v-select
              id="vue-select-rolling"
              v-model="globalFilter.rolling"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionRolling"
              :clearable="false"
              :placeholder="$t('No rolling')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <h6 class="mt-1">
        {{ $t('Filters') }}
      </h6>

      <b-row>
        <b-col>
          <!-- Project Select -->
          <b-form-group
            :label="$t('Project')"
            label-for="mc-project"
          >
            <v-select
              id="vue-select-project"
              v-model="globalFilter.projectId"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionProject"
              :reduce="project => project.id"
              label="projectName"
              :placeholder="$t('Select project...')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <form-filter
        v-if="globalFilter.projectId"
        v-model="globalFilter.filterConfig.filters"
        :project-id="globalFilter.projectId"
        :forfilter="true"
      />

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import FormFilter from '@/layouts/components/forms/FormFilter.vue'
import { checkFilterSyntax } from '@core/layouts/utils'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    vSelect,
    FormFilter,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      globalFilter: {
        fromWave: null,
        toWave: null,
        projectId: null,
        filterConfigJson: null,
        filterConfig: { filters: [] },
        rolling: 1,
      },
      required,
      optionPeriod: this.$store.state.globals.periodList,
      optionRolling: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      optionProject: [],
    }
  },
  async created() {
    this.globalFilter = JSON.parse(JSON.stringify(this.$store.state.globals.globalFilter))
    this.getProjectOptions()
  },
  methods: {
    getProjectOptions() {
      useJwt.axiosIns.get('project').then(response => {
        this.optionProject = response.data
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const updatedGlobalFilter = JSON.parse(JSON.stringify(this.globalFilter))
          delete updatedGlobalFilter.filterConfigJson
          if (!updatedGlobalFilter.rolling) {
            delete updatedGlobalFilter.rolling
          }
          if (updatedGlobalFilter.filterConfig.filters && updatedGlobalFilter.filterConfig.filters.length) {
            checkFilterSyntax(updatedGlobalFilter.projectId, updatedGlobalFilter.filterConfig.filters).then(response => {
              if (response.data) {
                this.$store.commit('globals/UPDATE_GLOBAL_FILTER', updatedGlobalFilter)

                this.$emit('filterApplied', updatedGlobalFilter)
                this.$bvModal.hide('modal-global-filter')
              } else {
                // show message
                this.$swal({
                  icon: 'warning',
                  title: 'Invalid Filter!',
                  text: this.$t('Please use operators to join filters...'),
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
          } else {
            this.$store.commit('globals/UPDATE_GLOBAL_FILTER', updatedGlobalFilter)

            this.$emit('filterApplied', updatedGlobalFilter)
            this.$bvModal.hide('modal-global-filter')
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';

</style>
